import { OverrideCredentials } from './overrideCredentials';
import { AssociationOutcome } from '../../../helpers/types';
import { postMspChildrenAssociation } from '../../../helpers/postMspChildrenAssociation';

export interface RunMspChildOverrideParams {
  tenantId: string;
  credentials: OverrideCredentials;
}

export const runMspChildOverride = ({
  tenantId,
  credentials
}: RunMspChildOverrideParams): Promise<AssociationOutcome> => {
  // Do not log - payload contains secretKey and clientId.
  const payload = {
    tenantIds: [tenantId],
    childTenantUUID: credentials.accountUuid,
    clientId: credentials.clientId,
    accessKey: credentials.secretKey
  };

  return postMspChildrenAssociation(payload);
};
